import * as React from 'react';

import {
  ShippingConfigActionContext,
  ShippingConfigValueContext,
} from './context';
import { useShippingConfigAction, useShippingConfigValue } from './hook';
import { initialState } from './initial';
import { reducer } from './reducer';

const ShippingConfigFormContext = ({
  children,
  ...props
}: React.PropsWithChildren<typeof initialState>) => {
  const [state, dispatch] = React.useReducer(reducer, {
    ...initialState,
    ...props,
  });
  return (
    <ShippingConfigValueContext.Provider value={state}>
      <ShippingConfigActionContext.Provider value={dispatch}>
        {children}
      </ShippingConfigActionContext.Provider>
    </ShippingConfigValueContext.Provider>
  );
};

export {
  ShippingConfigFormContext,
  useShippingConfigAction,
  useShippingConfigValue,
};
